import { type ExcalidrawFontFaceDescriptor } from "../Fonts";

import Regular from "./TicketRegular.woff2";

export const TicketRegularFontFaces: ExcalidrawFontFaceDescriptor[] = [
  // Thin  ExtraLight  Light  Regular  Medium  SemiBold  Bold  ExtraBold
  { uri: Regular },
];
